<template>
  <Modal v-model="modalVisible" title="同步意图" width="600px" :mask-closable="false" footer-hide>
    <Form :model="formData" ref="form" :label-width="120" :rules="rules">
      <FormItem label="选择话术" prop="sceneId">
        <Select v-model="formData.sceneId" placeholder="请输入话术名称搜索" filterable multiple :remote-method="remoteSearch"
          :loading="sceneListLoading" style="width: 100%">
          <Option v-for="scene in sceneList" :key="scene.id" :value="scene.id">
            {{ scene.sceneName }}
          </Option>
        </Select>
      </FormItem>

      <FormItem label="同步内容" prop="syncContent">
        <CheckboxGroup v-model="formData.syncContent">
          <Checkbox label="1" disabled>基本信息</Checkbox>
          <Checkbox label="2">关键词</Checkbox>
          <Checkbox label="3">其他设置</Checkbox>
        </CheckboxGroup>
      </FormItem>

      <FormItem label="重复处理" prop="duplicateHandle">
        <RadioGroup v-model="formData.duplicateHandle">
          <Radio label="cover">覆盖</Radio>
          <Radio label="skip">跳过</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="关键词处理" prop="keywordHandle"
        v-if="formData.syncContent.includes('2') && formData.duplicateHandle === 'cover'">
        <RadioGroup v-model="formData.keywordHandle">
          <Radio label="cover">覆盖</Radio>
          <Radio label="append">补充</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <div class="flex flex-end">
      <Button style="margin-right: 20px" @click="handleCancel">取消</Button>
      <Button type="primary" @click="handleSubmit" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { getAllScenesA } from '@/server/api'

export default {
  name: 'SyncModal',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sceneList: [],
      sceneListLoading: false,
      searchTimer: null,
      formData: {
        sceneId: [],
        syncContent: ['1'],
        duplicateHandle: 'cover',
        keywordHandle: 'cover'
      },
      loading: false,
      rules: {
        sceneId: [
          { required: true, type: 'array', min: 1, message: '请至少选择一个话术', trigger: 'change' }
        ],
        syncContent: [
          { required: true, type: 'array', min: 2, message: '请至少选择一项同步内容', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getSceneList('')
        this.resetForm()
      }
    }
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
  },
  methods: {
    async getSceneList(sceneName = '') {
      this.sceneListLoading = true
      try {
        const response = await getAllScenesA({
          is_llm: 0,
          pageSize: 1000,
          sceneName: sceneName,
        })
        if (response.code === 200) {
          this.sceneList = response.data?.data || []
        }
      } catch (error) {
        this.$Message.error('获取话术列表失败')
        console.error('获取话术列表错误:', error)
      } finally {
        this.sceneListLoading = false
      }
    },
    remoteSearch(query) {
      // 防抖处理
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.getSceneList(query)
      }, 300)
    },
    resetForm() {
      this.formData = {
        sceneId: [],
        syncContent: ['1'],
        duplicateHandle: 'cover',
        keywordHandle: 'cover'
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleSubmit() {
      this.loading = true
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.loading = false
          return false
        }
        // 传递回调函数，让父组件处理完成后调用
        this.$emit('onSubmit', { 
          ...this.formData 
        }, (error) => {
          this.loading = false
          if (error) {
            this.$Message.error(error.message)
            return
          }
          this.modalVisible = false
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
